module.exports = __webpack_public_path__ + "media/images/partners/CHT-5eb29df42b3f7e7a4e74074c7b395acf.png";